import { BarChart3, LineChart, ShieldCheck, Sparkles, Zap } from "lucide-react";

export type Highlight = {
  title: string;
  description: string;
  icon: React.ElementType;
};

export type Stat = {
  label: string;
  value: number;
  suffix: string;
};

export type TickerItem = {
  symbol: string;
  change: number;
};

export const highlights: Highlight[] = [
  {
    title: "AI-Driven Insights",
    description: "Leverage intelligent trading models to identify opportunities and manage risk with confidence.",
    icon: Sparkles,
  },
  {
    title: "Live Market Monitoring",
    description: "Track performance, positions, and execution data in one streamlined dashboard.",
    icon: BarChart3,
  },
  {
    title: "Secure Trading Workflow",
    description: "Connect your broker and keep your trading operations organized from a single platform.",
    icon: ShieldCheck,
  },
];

export const iconStrip = [Zap, Sparkles, LineChart, ShieldCheck];

export const stats: Stat[] = [
  { label: "Trades analyzed", value: 12400, suffix: "+" },
  { label: "Uptime", value: 99.9, suffix: "%" },
  { label: "Market monitoring", value: 24, suffix: "/7" },
];

export const tickerItems: TickerItem[] = [
  { symbol: "NIFTY 50", change: 0.84 },
  { symbol: "SENSEX", change: 0.62 },
  { symbol: "BANKNIFTY", change: -0.31 },
  { symbol: "RELIANCE", change: 1.42 },
  { symbol: "TCS", change: -0.58 },
  { symbol: "INFY", change: 0.97 },
  { symbol: "HDFCBANK", change: 0.23 },
  { symbol: "TATASTEEL", change: -1.05 },
];

export function useLandingPage() {
  return { highlights, iconStrip, stats, tickerItems };
}
